/**
 * The Work Orders list's column names (Figma 7453:980 headers, Manage Columns 7506:10414: "Source
 * differs: Manage Columns uses the code labels"), keyed by the view's column value.
 */
export const WORK_ORDER_COLUMN_LABELS: Record<string, string> = {
  work_order_number: 'ID',
  category: 'Categories',
  address: 'Address',
  market: 'Market',
  status: 'Status',
  technician: 'Technician(s)',
  provider: 'Provider',
  assignee: 'Assignee(s)',
  priority: 'Priority',
  due_date: 'Due Date',
  health_score: 'Health Score',
  scheduled_date: 'Scheduled',
  created_date: 'Created',
  tags: 'Tags',
};

/** Total Cost isn't a saved-view column: it shows whenever the user may see invoice costs. */
export const TOTAL_COST_COLUMN = { value: 'total_cost', label: 'Total Cost' } as const;
